// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__kDSS9","rightAdornment":"Header_rightAdornment__38-wJ"};